import { css } from 'styled-components';

export const fontRegular = css`
  font-family: var(--font-regular-family, sans-serif);
  font-weight: var(--font-regular-weight, 400);
  letter-spacing: var(--font-regular-letter-spacing, normal);
  text-transform: var(--font-regular-text-transform, none);
`;

export const fontBold = css`
  font-family: var(--font-bold-family, sans-serif);
  font-weight: var(--font-bold-weight, 700);
  letter-spacing: var(--font-bold-letter-spacing, normal);
  text-transform: var(--font-bold-text-transform, none);
`;
